import axios from 'axios';

import _store from '../data/Store';

import {ActionTypes} from '../data/ActionTypes';
/**
 * here we have the base url for all http request
 * that will be made to the REST API
 */
const DEV_url = 'https://maalportal.khuddam.ng/prod-service';
const LIVE_url = 'https://maalportal.khuddam.ng/prod-service';
export const url = DEV_url;

export const callback_url = 'https://maalportal.khuddam.ng/verify';


/**
 * here we have all the possible enpoints that can be
 * used to access data on the REST API
 */
// &status=APPROVED
export const endpoints = {
  SIGNUP: '/v1/auth/sign-up',
  LOGIN: '/auth-service/api/auth/authenticate',
  USER_DETAILS: '/auth-service/api/v1/users/current',
  PAYMENT_REQUEST: '/payment-service/api/v1/payment-requests?isSelfUser=true',
  PAYMENT_DETAILS:
    '/payment-service/api/v1/payment-details?isSelfUser=true&page=:page&size=:size&status=APPROVED',
  PAYMENT_DETAILS_WITH_DATES:
    '/payment-service/api/v1/payment-details?isSelfUser=true&page=:page&startDate=:startDate&endDate=:endDate&size=:size&status=APPROVED',

  GET_PAYMENT_REQUEST:
    '/payment-service/api/v1/payment-requests?isSelfUser=true&size=5',
  GET_PAYMENT_TEMPLATE: '/payment-service/api/v1/payment-requests/template',
  VERIFY_PAYMENT:
    '/paystack-service/transactions?trxref=:trxref&reference=:reference',
  DOWNLOAD_RECEIPT:
    'payment-service/api/v1/payment-details/download-receipt/:id?isSelfUser=true',
  DASHBOARD_DATA:
    'report-service/api/v1/dashboard?isSelfUser=true&paymentYear=:year',
};

/**
 * the in key is used to validate every request made to the REST API
 * this ensures that the request is secure and permitted.
 */
export const apiKey = '';

/**
 * default headers for http request
 */
export const headers = {
  'Content-Type': 'application/json',
};

function logout() {
  return {
    type: 'LOGOUT_REQUEST',
  };
}
async function logouts() {
  localStorage.removeItem("state");
  window.location = '/'
}

const setUpAuthorizedRequest = (data) => {
  return {
    type: ActionTypes.SET_UN_AUTHORIZED_TYPE,
    data: data,

  };
};

/**
 * parse error response
 */
function parseError(error) {
  console.log(error);
  if (!error) {
    return Promise.reject('An unknown error occured.');
  }

  if (typeof error === 'string') {
    return Promise.reject(error);
  }

  if (error && error.response) {
    console.log(error.response);

    if (error.response.status === 401) {
       _store.dispatch(logout());
      _store.dispatch(setUpAuthorizedRequest(true))
       logouts();

    }
    if (error.response.data && error.response.data.error) {
      return Promise.reject(error.response.data.error);
    }

    if (error.response.data && error.response.data.message) {
      return Promise.reject(error.response.data.message);
    }

    return Promise.reject('An unknown error occured.');
  }

  return Promise.reject(error.message || 'An unknown error occured.');
}

/**
 * parse response
 */
function parseBody(response) {
  const {data} = response;
  // _store.dispatch(setUpAuthorizedRequest(true))

  console.log(response);

  if (data) {
    console.log('yes');
    console.log(data);
    return data;
  } else {
    console.log('no');

    return parseError(new Error(data.error));
  }
}

let instance = axios.create({
  baseURL: url,
});

/**
 * add a response interceptor for axios instace
 */
instance.interceptors.response.use(
  (response) => {
    return parseBody(response);
  },
  (error) => {
    // if (__DEV__ && DEBUG) {
    //   console.log([error]);
    // }
    return parseError(error);
  },
);
function loadFromLocal() {
  try {
    const serializedState = localStorage.getItem('authData');
    if (serializedState === null) return undefined
    return JSON.parse(serializedState)
  } catch (e) {
    console.log(e)
    return undefined
  }
}

// request header
instance.interceptors.request.use(
  async (config) => {
    try {
      // get stored user
      // let user = await asyncGet(STORE_KEYS.AUTH_USER);


      const {auth} = _store.getState();
      console.log(auth);
      // add default headers
      config.headers = Object.assign({}, config.headers, headers);
      // check if a user was found
      if (auth.data) {
        // add user login token to request header
        config.headers = Object.assign({}, config.headers, {
          Authorization: `Bearer ${auth.data.token}`,
        });
      }
      // return transformed config
      return config;
    } catch (error) {
      // reject error if failed
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  },
);

/**
 * export instance as http
 */
export const http = instance;

export const cancelToken = axios.CancelToken;
